import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin((nuxtApp) => {
  const VALID_THEMES = ['dark-theme', 'light-theme', 'system']

  const getTheme = () => {
    if (import.meta.server) return 'dark-theme'
    const stored = localStorage.getItem('baserow-theme')
    if (VALID_THEMES.includes(stored)) return stored
    return 'dark-theme' // default theme
  }

  // Origem Flow: 'system' segue o tema do sistema operacional (linha 18
  // da tabela de ajustes — opção do usuário em Configurações).
  const resolveTheme = (theme) => {
    if (theme === 'system') {
      const prefersLight =
        typeof window !== 'undefined' &&
        window.matchMedia &&
        window.matchMedia('(prefers-color-scheme: light)').matches
      return prefersLight ? 'light-theme' : 'dark-theme'
    }
    return theme
  }

  const applyTheme = (theme) => {
    const html = document.documentElement
    html.classList.remove('light-theme', 'dark-theme')
    html.classList.add(resolveTheme(theme))
    // Origem Flow: os overrides visuais (antigo clickupStyles) vivem em
    // assets/scss/components/origem_theme.scss e entram no bundle de CSS.
  }

  const setTheme = (theme) => {
    if (import.meta.server) return
    if (!VALID_THEMES.includes(theme)) {
      theme = 'dark-theme'
    }
    localStorage.setItem('baserow-theme', theme)
    applyTheme(theme)
  }

  if (import.meta.client) {
    const theme = getTheme()
    setTheme(theme)

    // No modo 'system', acompanha mudanças de tema do SO ao vivo.
    if (window.matchMedia) {
      const media = window.matchMedia('(prefers-color-scheme: light)')
      const onChange = () => {
        if (getTheme() === 'system') {
          applyTheme('system')
        }
      }
      if (media.addEventListener) {
        media.addEventListener('change', onChange)
      }
    }

    // Origem Flow: o "+" de adicionar coluna do grid fica sem os handlers
    // do Vue (a subárvore do bloco perde a hidratação neste fork e nem o
    // mounted do head correspondente registra delegates). Fallback 100%
    // DOM, validado ao vivo: reproduz o fluxo vivo do menu da última
    // coluna, que abre o mesmo painel de campos ("Inserir à direita").
    if (!window.__origemFlowAddColumnFallback) {
      window.__origemFlowAddColumnFallback = true
      document.addEventListener('click', (event) => {
        const link =
          event.target.closest && event.target.closest('.grid-view__add-column')
        if (!link) {
          return
        }
        const cols = [
          ...document.querySelectorAll(
            '.grid-view__right .grid-view__head .grid-view__column'
          ),
        ].filter((col) => !col.querySelector('.grid-view__add-column'))
        const trigger =
          cols.length &&
          cols[cols.length - 1].querySelector(
            'a.grid-view__description-icon-trigger'
          )
        if (!trigger) {
          return
        }
        const synthetic = () =>
          new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window,
          })
        trigger.dispatchEvent(synthetic())
        setTimeout(() => {
          const items = [
            ...document.querySelectorAll(
              '.context:not(.visibility-hidden) .context__menu-item-link'
            ),
          ]
          const insertRight = items.find((item) =>
            item.querySelector('.iconoir-arrow-right')
          )
          if (insertRight) {
            insertRight.dispatchEvent(synthetic())
          }
        }, 200)
      })
    }
  }

  return {
    provide: {
      theme: {
        get: getTheme,
        set: setTheme,
        resolve: resolveTheme,
        toggle: () => {
          const current = resolveTheme(getTheme())
          const next = current === 'dark-theme' ? 'light-theme' : 'dark-theme'
          setTheme(next)
          return next
        },
      },
    },
  }
})
